// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2cHx0","overflowing":"ReadFullNote_overflowing__1CS0z"};